import DataTable, {Tip, Oper, Paging} from './DataTable';

export {Tip, Oper, Paging};
export default DataTable;


// WEBPACK FOOTER //
// ./src/components/DataTable/index.js